import { Mesh, PRIMITIVE_LINES } from 'playcanvas';

/**
 * Give a line mesh a valid (empty) vertex layout before its first real
 * rebuild. On WebGPU a mesh instance whose mesh has no vertex buffer yet
 * compiles the debug shader against a VertexInput with no `vertex_position`
 * member and the pipeline is rejected for every later frame; WebGL tolerated
 * the empty mesh, which is why the ported elements never seeded one.
 */
export const seedLineMesh = (mesh: Mesh): void => {
    mesh.setPositions([0, 0, 0, 0, 0, 0]);
    mesh.setColors32(new Uint8Array(8));
    mesh.update(PRIMITIVE_LINES);
    mesh.primitive[0].count = 0;
};
